
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { MolhamSingleTargetable } from "apiTypes";
import TargetablePage from "components/ReuseableCompos/SharedDonatePages/TargetablePage";
import SEO from "components/Seo";
import { getMixpanel } from "config/mixpanel";
import { DonateDetailsProvider } from "context/DonateDetailsContext";
import { DonatePageProvider } from "context/DonatePageContext";
import { TTargetType } from "customHooks/useUtilities";
import fs from "fs/promises";
import DonateIdLayout from "layout/DonateIdLayout";
import { useRouter } from "next/router";
import path from "path";
import { useEffect } from "react";
import removeUndefined from "utils/removeUndefined";
import { sendEvent } from "utils/sendEvent";
import { API_URL } from "../../config";
import { getData } from "../../utils/getData";
type Props = {
    singleCase: MolhamSingleTargetable;
    endPoint: string;
    sectionName: string;
    url: {
        endPoint: string;
        id: string;
        query: string;
    };
};
const CasesDetailsPage = ({ singleCase, endPoint, url, sectionName, }: Props) => {
    const router = useRouter();
    useEffect(() => {
        const mixpanel = getMixpanel();
        if (mixpanel) {
            mixpanel.track("Donate Page View", {
                "Page Name": singleCase?.contents?.title,
                "Page Short Name": singleCase?.contents?.short_name,
                "Page URL": window.location.pathname,
                "Page Section": sectionName,
                "Page Language": router.locale
            });
        }
        sendEvent({
            pixel: "ViewContent"
        }, {
            content_name: singleCase?.contents?.title,
            content_category: sectionName,
            content_ids: [singleCase?.id]
        });
    }, []);
    return (<>
      <SEO title={singleCase?.contents?.title} description={singleCase?.contents?.description} molhamImages={sectionName?.includes("event")
            ? undefined
            : singleCase?.preview_images?.[0]}/>
      <DonatePageProvider data={singleCase} endPoint={endPoint} url={url}>
        <DonateDetailsProvider data={singleCase}>
          <TargetablePage sectionName={sectionName} data={singleCase} url={url}/>
        </DonateDetailsProvider>
      </DonatePageProvider>
    </>);
};
export default CasesDetailsPage;
CasesDetailsPage.Layout = DonateIdLayout;
const getServerSideProps = async (ctx) => {
    ctx.res.setHeader("Cache-Control", "public, s-maxage=60, stale-while-revalidate=59");
    const token = ctx.req.cookies.token;
    const currency = ctx.req.cookies.currency;
    // Fetch the first page as default
    const locale = ctx.locale;
    let mainSectionsName = [];
    let currentSection: TTargetType | null = null;
    let singleCase = null;
    let endPoint: string | null = null;
    let query: string | null = null;
    let id = ctx.params.id;
    let ip = ctx.req.headers["cf-connecting-ip"] ||
        ctx.req.headers["x-forwarded-for"] ||
        ctx.req?.connection?.remoteAddress;
    let headers = {
        "x-forwarded-for": ip,
        locale,
        currency,
        "cf-ipcountry": ctx.req.headers?.["cf-ipcountry"],
        "x-forwarded-cf-ipcountry": ctx.req.headers?.["cf-ipcountry"]
    };
    headers = removeUndefined(headers);
    try {
        const utilities = await JSON.parse(await fs.readFile(path.join(process.cwd(), "constants", "utilities.json"), "utf8"));
        mainSectionsName = Object.keys(utilities.target_types);
        mainSectionsName.forEach((item) => {
            if (utilities.target_types[item]?.page_metadata?.path === ctx.params.donate) {
                currentSection = utilities.target_types[item];
            }
        });
        if (currentSection?.page_metadata?.path !== ctx.params.donate) {
            return {
                redirect: {
                    permanent: false,
                    destination: `/404`
                },
                // notFound: true,
                revalidate: 300
            };
        }
        endPoint = currentSection?.page_api_endpoint_path.split("?")[0];
        query = currentSection?.page_api_endpoint_path.split("?")[1];
        // Fetch data from external API
        try {
            const res = await getData(`${API_URL}/${currentSection?.page_api_endpoint_path}/${id}`, token ? token : null, 
            // undefined,
            headers, undefined);
            if (res.status !== 200) {
                throw new Error("Failed to fetch");
            }
            singleCase = res?.data;
        }
        catch (error) {
            singleCase = {
                error: { error: error?.message ?? "Failed to fetch" }
            };
        }
    }
    catch (error) {
        singleCase = {
            error: { error: error?.message ?? "Failed to fetch" }
        };
    }
    return {
        props: {
            singleCase,
            endPoint,
            sectionName: currentSection.name,
            revalidate: 300,
            url: {
                query: query ? query : null,
                endPoint,
                id
            }
        }
    };
    // let endpoint_url = "";
    // Pass data to the page via props
};

    async function __Next_Translate__getServerSideProps__1a13f66becb__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/[donate]/[id]',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a13f66becb__ as getServerSideProps }
  